import React from 'react';
import ReportAdminOverview from './components/ReportAdminOverview';
import './report.css';

const Report = () => {
  return (
    <div className="report-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-5xl">
        <ReportAdminOverview />
      </div>
    </div>
  );
};

export default Report;
